import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../../theme'

const TimeBlock = styled.div<ITimeBlockProps>`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 20px;

  ${is('sized')`
		font-weight: 500;
		font-size: 14px;
	`}

  &:hover {
    background-color: ${(props: ITheme) => props.theme.colors.palette.paleGrey};
  }
`

export default TimeBlock

export interface ITimeBlockProps {
  sized?: boolean
}
